export default __webpack_public_path__ + "static/media/Vice with Trolley2.3b81c4ab.jpg";